import { useState } from "react";
import { StepsStyle } from "../styles";
import {
  CheckCircleOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  ProfileOutlined,
  LoadingOutlined,
  MessageOutlined,
} from "@ant-design/icons";

interface StepsProps {
  stepsStatus: Array<"wait" | "process" | "finish" | "error">;
}

export default function Steps({
  stepsStatus = ["wait", "wait", "wait"],
}: StepsProps) {
  const steps = [
    {
      title: "Para onde?",
      status: stepsStatus[0],
      icon:
        stepsStatus[0] === "finish" ? (
          <CheckCircleOutlined style={{ color: "green" }} />
        ) : stepsStatus[0] === "process" ? (
          <LoadingOutlined spin />
        ) : (
          <EnvironmentOutlined />
        ),
    },
    {
      title: "Qual período?",
      status: stepsStatus[1],
      icon:
        stepsStatus[1] === "finish" ? (
          <CheckCircleOutlined style={{ color: "green" }} />
        ) : stepsStatus[1] === "process" ? (
          <LoadingOutlined spin />
        ) : (
          <CalendarOutlined />
        ),
    },
    {
      title: "Pagamento/Troca",
      status: stepsStatus[2],
      icon:
        stepsStatus[2] === "finish" ? (
          <CheckCircleOutlined style={{ color: "green" }} />
        ) : stepsStatus[2] === "process" ? (
          <LoadingOutlined spin />
        ) : (
          <ProfileOutlined />
        ),
    },
  ];

  return <StepsStyle items={steps} />;
}
